<template>
  <v-dialog v-model="showDialog" persistent max-width="1000px">
    <v-card>
      <!-- <v-card-title  color="primary darken-4">
                                <span class="headline">AGREGAR SUCURSAL</span>
                            </v-card-title> -->
      <v-toolbar color="primary darken-4" dark>
        <img
          :src="$store.state.iconoForm"
          height="42"
          alt="Acciones marca producto"
        />
        <v-toolbar-title class="ml-0 pl-3">
          <span class="hidden-sm-and-down">{{ $store.state.tituloForm }}</span>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click.native="showDialog = false">
          <v-icon danger>close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-divider></v-divider>
      <v-card-text>
        <v-container grid-list-md>
          <v-form ref="formMarcaProducto" :v-model="true" lazy-validation>
            <v-flex xs12 sm12 md12>
              <v-text-field
                label="Nombre de la marca *"
                v-model="marca.nombreMarca"
                placeholder="Marca de producto: OSCAR DE LA RENTA, TOMMY, IZOD"
                hint="Marca de producto: OSCAR DE LA RENTA, TOMMY, IZOD"
                :rules="[() => !!marca.nombreMarca || 'El campo es requerido']"
                :counter="60"
                required
              ></v-text-field>
            </v-flex>
          </v-form>
        </v-container>
        <br />
        <small>* Indica que el campo es requerido</small>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn depressed @click.native="showDialog = false">Cerrar</v-btn>
        <v-btn
          color="primary darken-4"
          :loading="$store.state.operationInProgress"
          @click="saveMarca"
          >Guardar</v-btn
        >
      </v-card-actions>
      <v-alert
        :value="$store.state.operationSuccess"
        color="success"
        icon="check_circle"
        transition="scale-transition"
      >
        Marca guargada con éxito
      </v-alert>
      <v-alert
        :value="$store.state.operationFailed"
        color="error"
        icon="warning"
        transition="scale-transition"
      >
        <span v-html="$store.state.errorMessage"></span>
      </v-alert>
    </v-card>
  </v-dialog>
</template>

<script>
import marcaProductoService from "@/services/marcaProductoService";

export default {
  props: {
    marca: {
      type: Object,
    },
  },
  data() {
    return {
      showDialog: false,
    };
  },
  methods: {
    openDialog() {
      this.showDialog = true;
    },
    saveMarca() {
      let self = this;

      if (self.$refs.formMarcaProducto.validate()) {
        self.operationStart();

        if (self.marca.marcaId === 0) {
          self.addMarca();
        } else {
          self.updateMarca();
        }
      }
    },
    addMarca() {
      let self = this;

      marcaProductoService
        .add(self.marca)
        .then((result) => {
          self.operationSuccess();

          //Enviar tipo producto al componente padre
          self.$emit("onMarcaAdded", result);

          setTimeout(() => {
            self.showDialog = false;
            self.resetForm();
          }, 2000);
        })
        .catch((e) => {
          self.operationFailed(e);
          console.log(e);
        });
    },
    updateMarca() {
      let self = this;

      marcaProductoService
        .update(self.marca)
        .then((result) => {
          self.operationSuccess();

          //Enviar tipo producto al componente padre
          self.$emit("onMarcaUpdated", result);

          setTimeout(() => {
            self.showDialog = false;
            self.resetForm();
          }, 2000);
        })
        .catch((e) => {
          console.log(e);
          self.operationFailed(e);
        });
    },
    resetForm() {
      let self = this;
      self.operationReset();
      self.$refs.formMarcaProducto.resetValidation();
      self.marca.marcaId = 0;
      self.marca.nombreMarca = "";
    },
  },
};
</script>
